// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".response[data-v-7eb8ae56]:nth-child(2n){background-color:rgba(24,39,69,.05)}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Coachs/Results.vue"],"names":[],"mappings":"AACA,yCACE,mCAAF","sourcesContent":["\n.response:nth-child(even) {\n  background-color: rgba(24, 39, 69, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
